import _ from 'underscore';

export class DeviceType {
  constructor() {
    const ua = window.navigator.userAgent.toLocaleLowerCase();
    this.isIOS = /iphone|ipad|ipod/.test(ua);
    this.isAndroid = /android/.test(ua);
  }
}

// 判断客户端
export const agent = (() => {
  const url = window.location.href;
  if (
    window.navigator.userAgent.includes(';MG')
    || window.navigator.userAgent.includes('Roewe')
  ) {
    // app内嵌
    return 'native';
  }
  if (
    url.includes('mp=true')
    || url.includes('ismp=1')
    || sessionStorage.getItem('mp')
    || window.__wxjs_environment === 'miniprogram'
    || window.location.href.includes('mp=true') > 0
  ) {
    // 小程序
    return 'mp';
  }
  // 浏览器h5
  return 'wap';
})();

/*
 * 金额格式化
 * number：要格式化的数字
 * decimals：保留几位小数
 * */
export function priceFormat(number, decimals) {
  if (number < 999) {
    return number;
  }
  const numberRep = `${number}`.replace(/[^0-9+-Ee.]/g, '');
  const n = !Number.isFinite(+numberRep) ? 0 : +numberRep;

  const prec = !Number.isFinite(+decimals) ? 0 : Math.abs(decimals);

  const sep = ',';

  const dec = '.';

  let s = '';

  function toFixedFix(_n, _prec) {
    const k = 10 ** _prec;
    return `${Math.ceil(_n * k) / k}`;
  }

  s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, `$1${sep}$2`);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}
// 取到url参数
export function getUrlParams(href) {
  const url = href || window.location.href;
  if (url.indexOf('?') === -1) {
    return false;
  }
  const urlArr = url.split('?');
  const result = {};
  for (let i = 1; i < urlArr.length; i += 1) {
    const paramString = urlArr[i];
    const arr = paramString.split('&');
    for (let j = 0; j < arr.length; j += 1) {
      const objArr = arr[j].split('=');
      if (objArr[0] && objArr[1]) {
        const key = objArr[0];
        const val = objArr[1];
        result[key] = val;
      }
    }
  }
  return result;
}
/**
 * 将图片url转换为base64
 */
export function getBase64ByUrl(url, cb) {
  const image = new Image();
  image.setAttribute('crossOrigin', 'Anonymous');
  image.src = `${url}`;
  image.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    context.drawImage(image, 0, 0, image.width, image.height);
    const base64 = canvas.toDataURL('image/png', 0);
    if (typeof cb === 'function') {
      cb(base64);
    }
  };
}

export default {
  DeviceType,
  agent,
  _,
  priceFormat,
  getUrlParams,
};
